<app-input-label [inputId]="id" [inputName]="name" [mandatory]="mandatory" [helpTooltipText]="helpTooltipText"></app-input-label>

<div class="input">
  <ng-container *ngFor="let item of possibleValues; let i = index">
    <div class="button-container" [class.margin-right]="!isLastItem(possibleValues, i)">
      <app-button
        [text]="numberToString(item)"
        [outline]="!(item === value)"
        (clickEvent)="handleInput(item)"
        [shortPadding]="true"
      ></app-button>
    </div>
  </ng-container>
</div>
